class AboutUs {
  constructor() {
    this.init();
  }

  init() {
    this.handleMenu();
  }

  handleMenu() {
    const menus = document.querySelectorAll('.about-us__left-name');

    menus?.forEach((menu, index) => {
      menu.addEventListener('click', () => {
        this.clearActiveClasses();
        const content = document.querySelector(`.about-us__right[data-number="${index}"]`);

        menu.classList.add('active');
        content?.classList.add('active');
      });
    })
  }

  clearActiveClasses() {
    const menus = document.querySelectorAll('.about-us__left-name');
    const contents = document.querySelectorAll('.about-us__right');
    menus?.forEach(menu => menu.classList.remove('active'));
    contents?.forEach(content => content.classList.remove('active'));
  }
}

new AboutUs();